/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IAssessments {

    }

    class Assessments implements IAssessments {
        static controllerId: string = "assessments";
        static $inject: string[] = ["common", "Restangular", "config"];

        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        lsiAccess: boolean;
        dwyaAccess: boolean;
        skillsAccess: boolean;
        intelligencesAccess: boolean;
        umbracoUrl: string;

        assessments: IAssessment[];

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private config: IConfig) {

            this.log = common.logger.getLogFn(Assessments.controllerId);
            this.logError = common.logger.getLogFn(Assessments.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(Assessments.controllerId, "success");
            this.umbracoUrl = config.umbracoUrl;

            this.common.authentication.authenticate(true).then(() => {
                this.activate();
            });

        }


        activate() {
            this.assessments = [];
            var promises = [this.getAssessments(), this.hesAccess()];
            this.common.activateController(promises, Assessments.controllerId)
        }

        getAssessments() {
            return this.Restangular.one("assessments").get()
                .then((result) => {
                    this.assessments = this.assessments.concat(result);

                }, (reason) => {
                    this.logError(reason.message, reason, false);
                });
        }

        hesAccess() {
            return this.Restangular.one("learnaboutyourself/canaccess").get()
                .then(result => {
                    this.lsiAccess = result.lsiAccess;
                    this.dwyaAccess = result.dwyaAccess;
                    this.skillsAccess = result.skillsAccess;
                    this.intelligencesAccess = result.intelligencesAccess;
                    if (this.dwyaAccess) {
                        this.assessments.push({
                            id: 0,
                            name: "AchieveWorks\u00AE Personality",
                            formerName: "Do What You Are",
                            description: "This recently updated assessment helps you learn about your personality type.",
                            durationMax: 35,
                            durationMin: 20,
                            questions: null,
                            urlName: "/learn-about-yourself/achieveworks-personality"
                        });
                    }

                    if (this.lsiAccess) {
                        this.assessments.push({
                            id: 0,
                            name: "AchieveWorks\u00AE Learning & Productivity",
                            formerName: "Learning Style Inventory",
                            description: "This recently updated assessment helps you find out the most effective ways for you to learn.",
                            durationMax: 20,
                            durationMin: 15,
                            questions: null,
                            urlName: "/learn-about-yourself/achieveworks-learning-productivity"
                        });
                    }

                    if (this.skillsAccess) {
                        this.assessments.push({
                            id: 0,
                            name: "AchieveWorks\u00AE Skills",
                            formerName: null,
                            description: "Identify your skills and matching careers.",
                            durationMax: 20,
                            durationMin: 15,
                            questions: null,
                            urlName: "/learn-about-yourself/achieveworks-skills"
                        });
                    }

                    if (this.intelligencesAccess) {
                        this.assessments.push({
                            id: 0,
                            name: "AchieveWorks\u00AE Intelligences",
                            formerName: null,
                            description: "Find out how you deal with information, solve problems, and create things.",
                            durationMax: 20,
                            durationMin: 15,
                            questions: null,
                            urlName: "/learn-about-yourself/achieveworks-intelligences"
                        });
                    }
                });
        }

        getUrl(str) {
            return str.replace(/\s/g, '-').toLowerCase();
        }
    }


    angular.module("app").controller(Assessments.controllerId, Assessments);
}